module.exports = __webpack_public_path__ + "img/evaluateItemLogo1.28d18017.png";